import { createChannelDescriptor } from "./channel-descriptor.js";

export function toggleThemeClasses(
  theme: "light" | "dark",
  container: HTMLElement,
  classNames: string[]
) {
  if (theme === "light") {
    container.classList.remove(...classNames);
  } else {
    container.classList.add(...classNames);
  }
}

export function createThemeChannel<TDomain extends "host" | "remote">(
  domain: TDomain
) {
  return createChannelDescriptor(domain, "theme", {
    remoteMethods: () => ({
      setTheme: (theme: "light" | "dark") => {
        toggleThemeClasses(theme, document.documentElement, [
           // Meta layer styles (default global.css styles)
          "dark",

          // Sketch styles (custom grayscale styles)
          "dark__sketch", 
        ]);
      },
    }),
  });
}
